import { createContext } from 'react';
import type {
  HeaderContextValue,
  ContextSearchContextValue,
} from './interfaces';

export const HeaderContextContext = createContext<HeaderContextValue>(null);
export const ContextSearchContext = createContext<ContextSearchContextValue>(null);